let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iXiaJ")).then(() => parcelRequire('eS7e3'));